const BASE58_ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
const BASE58_INDEX = new Map(Array.from(BASE58_ALPHABET, (character, index) => [character, index]));
const BASE58_CANDIDATE = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;

export const isSolanaTokenAddress = (value: string) => {
  if (!BASE58_CANDIDATE.test(value)) return false;

  const bytes = [0];
  for (const character of value) {
    const digit = BASE58_INDEX.get(character);
    if (digit == null) return false;
    let carry = digit;
    for (let index = 0; index < bytes.length; index += 1) {
      carry += bytes[index] * 58;
      bytes[index] = carry & 0xff;
      carry >>= 8;
    }
    while (carry > 0) {
      bytes.push(carry & 0xff);
      carry >>= 8;
    }
  }

  const leadingZeroes = value.match(/^1*/)?.[0].length || 0;
  const significantBytes = bytes.length === 1 && bytes[0] === 0 ? 0 : bytes.length;
  return leadingZeroes + significantBytes === 32;
};

export const extractSolanaTokenAddresses = (text: string) => {
  const unique = new Set<string>();
  text
    .split(/[^1-9A-HJ-NP-Za-km-z]+/)
    .filter(isSolanaTokenAddress)
    .forEach((address) => unique.add(address));
  return Array.from(unique);
};

export const countSolanaTokenCandidates = (text: string) => text
  .split(/[^1-9A-HJ-NP-Za-km-z]+/)
  .filter(isSolanaTokenAddress)
  .length;
